import { assert } from '@ember/debug';
import loadConfigFromMeta from '@embroider/config-meta-loader';
import type { EmberSentryConfig } from '@sentry/ember/types';

const config = loadConfigFromMeta('lumen') as unknown;

assert(
  'config is not an object',
  typeof config === 'object' && config !== null,
);
assert(
  'modulePrefix was not detected on your config',
  'modulePrefix' in config && typeof config.modulePrefix === 'string',
);
assert(
  'locationType was not detected on your config',
  'locationType' in config && typeof config.locationType === 'string',
);
assert(
  'rootURL was not detected on your config',
  'rootURL' in config && typeof config.rootURL === 'string',
);
assert(
  'APP was not detected on your config',
  'APP' in config && typeof config.APP === 'object',
);

export default config as {
  APP: Record<string, unknown>;
  locationType: string;
  modulePrefix: string;
  podModulePrefix?: string;
  rootURL: string;
} & {
  '@googlemaps/js-api-loader': {
    key: string;
  };
  '@sentry/ember': EmberSentryConfig;
  BUILD_TARGET?: 'production' | 'staging';
  FIREBASE_CONFIG: {
    apiKey: string;
    authDomain: string;
  };
  adminUserURL: string;
  analytics: {
    apiHost: string;
    cdnURL: string;
    enableLogging: boolean;
    enabled: boolean;
    writeKey: string;
  };
  autoRetryTests: boolean;
  deToolsURL: string;
  'ember-cli-app-version': {
    version: string;
  };
  ernestURL: string;
  identityPlatformProxyPath: string;
  intercom: {
    appId: string;
    isEnabled: boolean;
  };
  isDevelopmentOrTest: boolean;
  isProduction: boolean;
  isStaging: boolean;
  isStagingOrDevelopment: boolean;
  launchDarkly: {
    baseUrl: string;
    clientId: string;
    eventsUrl: string;
    streamUrl: string;
  };
  lookerEmbedURL: string;
  'mixpanel-browser': {
    apiHost: string;
    token: string;
  };
  routeManifestEnabled: boolean;
  satismeter: {
    enabled: boolean;
  };
  spiderIframeURL: string;
  staticURL: string;
  useDevApi: boolean;
  usersnap: {
    enabled: boolean;
    spaceAPIKey: string;
  };
} & Record<string, unknown>;
